// extracted by mini-css-extract-plugin
export default {"content":"DuplicatesMailSpacePromoModal__content--2U9SF","imageWrapper":"DuplicatesMailSpacePromoModal__imageWrapper--2MySn"};